import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import TermConditions from '../../_components/Global/TermConditions.modal';
import PrivacyPolicy from '../../_components/Global/PrivacyPolicy.modal';

import { history } from '../../_helpers';
import { userActions } from '../../_actions';
import { SubmitButton } from '../../_components';

import CellLogo from '../../_assets/cell_logo.png';

import './Signin.scss';
import 'react-toastify/dist/ReactToastify.css';

import ReCAPTCHA from "react-google-recaptcha";

class SigninContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      keepLogged: false,
      submitted: false,
      empty: false,
      recaptcha: ""
    }

    this.keepConnectedInput = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setKeepConnected = this.setKeepConnected.bind(this);
    this.changeCaptchaValue = this.changeCaptchaValue.bind(this);
  }

  componentDidMount() {
    this.setState({recaptcha: ""});

    if ( sessionStorage.getItem('cellit_userdata') ) return history.push('/');

    document.title = 'Signin - Cellit.io';

    if ( !history.location.state ) return;
    if ( !history.location.state.userValidationComplete ) return;

    return toast.success('Usuário validado com sucesso!', {
      position: toast.POSITION.TOP_RIGHT,
      className: 'toast-success'
    });
  }

  handleChange(e) {
    let val = e.target.value;
    let name = e.target.name;
  
    this.setState({[name]: val});
  }

  handleSubmit(e) {
    e.preventDefault();

    if(!this.state.recaptcha || this.state.recaptcha.length === 0) {
      toast.warning('O campo reCAPTCHA é obrigatório!', {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-warning'
      });

      return false
    }
    
    this.setState({submitted: true});

    const { username, password } = this.state;
    const { dispatch } = this.props;
    
    const obj = {
      "user": {
        "username": username,
        "password": password
      }
    }

    if ( username && password ) {  
      this.setState({empty: false});

      return dispatch(userActions.signin(obj))
        .then(data => {
          if ( data.type !== "USER_SIGNIN_FAILURE" ) return;

          toast.error(data.error.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-error'
          });

          this.setState({submitted: false});
        })
    }

    this.setState({empty: true, submitted: false});
  }

  setKeepConnected() {
    this.keepConnectedInput.current.click()
  }

  changeCaptchaValue(e) {
    this.setState({recaptcha: e});
  }

  render() {
    const { username, password, submitted, empty } = this.state;

    return (
      <div className="login">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5">
            
              <div className="login-panel">
                <img src={CellLogo} className="logo" alt="Cellit logo" />
                
                <div className="content">
                  <h1 className="title">Cellit.io</h1>
                  <p className="subtitle">Seja bem-vindo! Realize seu login abaixo ou registre-se.</p>

                  <form id="login-form" method="POST" className="form" onSubmit={this.handleSubmit}>
                    <div className="content-group">
                      <div className="form-group form-group-separator">
                        <input
                          type="text"
                          name="username"
                          id="username"
                          className={empty && !username ? 'form-control form-control-error' : 'form-control'}
                          autoComplete="off"
                          onChange={this.handleChange}
                          defaultValue={this.state.username}
                        />
                        <label htmlFor="username">Usuário</label>
                        {empty && !username && <div className="input-error">Informe seu nome de usuário</div>}
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          name="password"
                          id="password"
                          className={empty && !password ? 'form-control form-control-error' : 'form-control'}
                          onChange={this.handleChange}
                          defaultValue={this.state.password}
                        />
                        <label htmlFor="password">Senha</label>
                        {empty && !password && <div className="input-error">Informe sua senha</div>}
                      </div>
                    </div>

                    <div className="row row-options">
                      <div className="col">
                        <ReCAPTCHA
                          sitekey="6LeCQycrAAAAAEkfzOLxqr8a_5luxMnpV-mN7n3t"
                          onChange={this.changeCaptchaValue}
                        />
                      </div>
                    </div>

                    <div className="row row-options">
                      <div className="col">
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" value="" id="defaultCheck1" ref={this.keepConnectedInput}/>
                          <span className="checkbox checkbox-default" onClick={this.setKeepConnected}></span>
                          <label className="form-check-label" htmlFor="defaultCheck1">
                            Manter conectado
                          </label>
                        </div>
                      </div>
                      {/* <div className="col">
                        <Link to="/recovery">Esqueci minha senha</Link>
                      </div> */}
                    </div>

                    <SubmitButton
                      type="submit"
                      color="blue"
                      submitted={submitted}
                      text="Entrar"
                      altText="Entrando..."
                    />
                    {/* <Link to="/signup/company" className="btn btn-white-outlined">Registrar</Link> */}
                  </form>

                  <p className="disclaimer">
                    Ao registrar-se, você concorda com: Cellit.io <br></br>
                    <button type="button" data-toggle="modal" data-target="#TermAndConditionsModal" onClick={this.handleModalOpen} className="modal-terms-link signin">Termos e condições </button>
                    &amp; 
                    <button type="button" data-toggle="modal" data-target="#PrivacyPolicyModal" onClick={this.handleModalOpen} className="modal-terms-link">Política de Privacidade</button>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md hidden-xs visible-lg">
              <div className="image-placeholder" style={{backgroundImage: 'url(https://picsum.photos/1480/928)'}}>
              </div>
            </div>
          </div>
        </div>

        <TermConditions />

        <PrivacyPolicy />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { signingIn } = state.signinReducer;
  return { signingIn };
}

const ConnectedSigninContainer = connect(mapStateToProps)(SigninContainer);
export { ConnectedSigninContainer as SigninContainer }